import React,{useEffect} from 'react'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useNavigate} from 'react-router-dom'
import { base_url, header_api } from '../Services/Apis';
import Cookies from 'js-cookie';

const GetHeaders = () => {

    const navigate = useNavigate()
    const params = new URLSearchParams(window.location.search)
    const extId = params.get('ext_ref')

    const ApiHit=async()=>{
        try{
            const res = await axios.post(`${header_api}`)
            console.log(res.data)
            if(res.data == 'Msisdn Not Found'){
                // console.log("in msisnd")
                navigate(`/subscribe?ext_ref=${extId}`)
                return;
            }
            Cookies.set('number',res.data,{expires:1});
        
            navigate(`/pack?ext_ref=${extId}`)
        }
        catch(err){
            // console.log(err)
            toast.err(err.response.data)
            navigate(`/subscribe?ext_ref=${extId}`)
        }
    }

    // useEffect(()=>{
    //     ApiHit();
    // })

  return (
    <div>
      {/* <ToastContainer/> */}
    </div>
  )
}

export default GetHeaders
